import API, { baseURL } from './api';
import { getSucursalInfo, getUserInfo } from './auth';

// Client for sge_infantil_core's routes/expenses.js (mounted at /api/expenses).
// startDate/endDate ("YYYY-MM-DD") scope the query by date range instead of
// year+month - the backend requires one or the other.
export async function listExpenses({ sucursalId, year, month, expenseType, startDate, endDate } = {}) {
  const id = sucursalId || getSucursalInfo()?.id || 1;
  return API.get(`${baseURL}api/expenses/${id}`, { params: { year, month, expenseType, startDate, endDate } });
}

export async function listAllExpenses(sucursalId) {
  const id = sucursalId || getSucursalInfo()?.id || 1;
  return API.get(`${baseURL}api/expenses/all/${id}`);
}

export async function createExpense(payload) {
  const sucursalId = getSucursalInfo()?.id || 1;
  const user = getUserInfo();
  return API.post(`${baseURL}api/expenses`, {
    sucursalId,
    createdBy: user?.id,
    createdByUser: user?.name,
    ...payload,
  });
}

export async function updateExpense(id, payload) {
  return API.put(`${baseURL}api/expenses/${id}`, { updatedBy: getUserInfo()?.id, ...payload });
}

export async function deleteExpense(id) {
  return API.delete(`${baseURL}api/expenses/${id}`);
}

export async function listExpenseTypes(sucursalId) {
  const id = sucursalId || getSucursalInfo()?.id || 1;
  return API.get(`${baseURL}api/expenseTypes/${id}`);
}

// Categorias (SGE_EXPENSE_TYPES) vêm da BD, filtradas por `kind` (FIXA/
// VARIAVEL) no wizard de Cadastrar Despesa - ver CadastrarDespesaLayer.
// Criar uma categoria ad-hoc (não listada) ainda é possível a partir do
// wizard; nesse caso `suggestedAccount` fica por preencher até a
// Contabilidade mapear a conta manualmente.
export async function createExpenseType(name, sucursalId, kind, suggestedAccount) {
  const id = sucursalId || getSucursalInfo()?.id || 1;
  return API.post(`${baseURL}api/expenseTypes`, { name, sucursalId: id, kind, suggestedAccount });
}

export async function listExpenseFunds(sucursalId) {
  const id = sucursalId || getSucursalInfo()?.id || 1;
  return API.get(`${baseURL}api/expenseFunds/${id}`);
}

// Fundos de Despesa (SGE_EXPENSE_FUNDS) vêm da BD, sempre disponíveis
// independentemente do `kind` (FIXA/VARIAVEL) - ao contrário da Categoria,
// não são filtrados no wizard de Cadastrar Despesa. "Pagamento de Propinas"
// é pré-seleccionado por omissão (ver CadastrarDespesaLayer), mas o
// utilizador pode escolher/criar outro fundo tal como faz com a Categoria.
export async function createExpenseFund(name, sucursalId) {
  const id = sucursalId || getSucursalInfo()?.id || 1;
  return API.post(`${baseURL}api/expenseFunds`, { name, sucursalId: id });
}
